import * as React from 'react';
import { useEffect, useRef } from 'react';
import { translate } from '@js/common/helpers';
import { DayColumn } from './DayColumn';
function findDayIndex(days, dayKey) {
    for (var i = 0; i < days.length; i++) {
        if (days[i].dayKey === dayKey) {
            return i;
        }
    }
    return -1;
}
export function DayScroller(_a) {
    var days = _a.days, season = _a.season, type = _a.type, userEmail = _a.userEmail, scrollToDayKey = _a.scrollToDayKey;
    var railRef = useRef(null);
    useEffect(function () {
        var rail = railRef.current;
        if (rail === null || !scrollToDayKey) {
            return;
        }
        var index = findDayIndex(days, scrollToDayKey);
        if (index < 0) {
            return;
        }
        var column = rail.children[index];
        if (!column) {
            return;
        }
        rail.scrollLeft += column.getBoundingClientRect().left - rail.getBoundingClientRect().left;
    }, [days, scrollToDayKey]);
    if (days.length === 0) {
        return React.createElement("p", { className: "agenda-empty" }, translate('calendar.no_shows'));
    }
    return (React.createElement("div", { className: "day-scroller-rail", ref: railRef }, days.map(function (day) { return (React.createElement(DayColumn, { key: day.dayKey, day: day, season: season, type: type, userEmail: userEmail })); })));
}
